import { Injectable } from '@angular/core';
import { WebserviceService, WmHttpService, OauthService, I18nService, RouterHistoryService,ProjectService, TypeFactoryService, ServiceFactoryService, NotificationService } from '@wms/services';
import { HTTP_METHODS, WS_CONSTANTS, OPERATIONS } from '@wms/core';
import { VARIABLE_CONSTANTS } from '@wms/variables';
import { cloneDeep, concat, find, filter, includes, toLower, get, findIndex, isEqual } from 'lodash-es';
import {  Subject} from 'rxjs';
import { Router, RouterStateSnapshot } from '@angular/router';
import {Location} from '@angular/common';
import { DialogService } from '@wms/app/services/dialog/dialog.service';
import {inject} from '@angular/core';
import { environment } from "@wms/app";
import { WmsWorkspaceManagerService } from "@wms/workspace";
import { EventManagerService } from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class ApisService {
  dataTypes: any;

  requestQueue: any = {
    'services': [],
    'operations': {},
    'serviceDef': {},
    'prefabTypes': {}
  }

  serviceApiMap: any = {};
  teamProjects: any;
  activeApi: any;
  reimportedServiceId: string;
  fetchControllersInfo: boolean;
  reimportRefreshData: boolean;
  currentApiType: any;
  selectedTab: any;
  apiDesignerTabs: any;
  selectedApiNode: any;
  apiDesignerProps: any = {
    filteredMethods: []
  };
  filteredPaths_length: any;

  projectApiMap = {};
  projectServiceApiMap = {};
  hideActions: boolean = false;
  loadingApi = false;
  emptyScreenCounter: number = 0;
  soapServices: any;

  config: any;
  serviceId: any;
  authorizationUrl: any;
  providerId: any;

  activeProvider: any;
  spinnerMessage: any;
  noServicesFound = false;
  tagInfoOriginal: any;
  swaggerInfo: any;
  importDialogOpened: boolean;

  public serviceTypeConstants: any;
  public RELATIVE_PATH_KEY = 'x-WM-RELATIVE_PATH';
  public BASE_PATH_KEY = 'x-WM-BASE_PATH';
  allMethods = concat('All Methods', HTTP_METHODS);
  activeApiHead: any;
  searchKeys = { 'methodType': 'All Methods' };
  currentService: any;
  activeServiceType: any;
  importedApiServices: any;
  services: any;
  allServices: any = [];
  filteredServices: any;
  models: any;
  locale: any;
  lastActiveUrl: any;
  isSettingsApi: boolean;
  showSecurityMsg: any;
  isMockEnabled: boolean = false;
  mockServerIntroDone: boolean;
  typeService: any;
  currentActiveNode: any;
  CORE_API_SERVICES: string[] = ['SoapService', 'SecurityServiceType', 'JavaService'];
  nextState: RouterStateSnapshot | null;
  apiToLoadNext: any
  private wsManager: WmsWorkspaceManagerService;
  originalSwaggerSpec: any;
  smdialogData: number = 0;

  QUERY_CONTROLLER = WS_CONSTANTS.CONTROLLER_NAMES.QUERY_CONTROLLER;
  PROCEDURE_CONTROLLER = WS_CONSTANTS.CONTROLLER_NAMES.PROCEDURE_CONTROLLER;

  SERVICE_TYPE_FEED = VARIABLE_CONSTANTS.SERVICE_TYPE_FEED;
  SERVICE_TYPE_REST = VARIABLE_CONSTANTS.SERVICE_TYPE_REST;
  SERVICE_TYPE_SOAP = VARIABLE_CONSTANTS.SERVICE_TYPE_SOAP;
  SERVICE_TYPE_JAVA = VARIABLE_CONSTANTS.SERVICE_TYPE_JAVA;
  SERVICE_TYPE_DATA = VARIABLE_CONSTANTS.SERVICE_TYPE_DATA;
  SERVICE_TYPE_MODEL = VARIABLE_CONSTANTS.SERVICE_TYPE_MODEL;
  SERVICE_NAME_FEED = VARIABLE_CONSTANTS.SERVICE_NAME_FEED;
  SERVICE_TYPE_WEBSOCKET = VARIABLE_CONSTANTS.SERVICE_TYPE_WEBSOCKET;
  REST_SUPPORTED_SERVICES = VARIABLE_CONSTANTS.REST_SUPPORTED_SERVICES;

  RUNTIME_CALL_MODE = {
    PROXY: 'PROXY',
    DIRECT: 'DIRECT'
  };
  isReloadServices = false; // TO DO

  public apiDesignerService: any = [
    {
      name: 'project-name',
      subGroups: [
        {
          name: "core-apis",
          namekey: "LABEL_CORE_APIS",
          iconclass: "api-head",
          children: [
            {
              name: "db-services",
              servicename: "DataService",
              namekey: "LABEL_DATABASE_SERVICE",
              iconclass: "",
              children: []
            },
            {
              name: "java-services",
              servicename: "JavaService",
              namekey: "LABEL_JAVA_SERVICE",
              iconclass: "wms wms-java-service",
              chidlren: []
            },
            {
              name: "security-services",
              servicename: "SecurityServiceType",
              namekey: "LABEL_SECURITY_SERVICE",
              iconclass: "wms wms-security-service",
              chidlren: []
            },
            {
              name: "soap-services",
              servicename: "SoapService",
              namekey: "LABEL_SOAP_SERVICE",
              iconclass: "wms wms-soap-service",
              children: []
            },
            {
              name: "web-services",
              servicename: "WebService",
              namekey: "LABEL_WEB_SERVICE",
              iconclass: "wms wms-internet",
              hide: true,
              children: []
            }
          ]
        },
        {
          name: "imported-apis",
          namekey: "LABEL_IMPORTED_APIS",
          iconclass: "api-head",
          children: [
          ],
          allowAdd: true,
          addTitle: "LABEL_IMPORT_NEW_API"
        },
        {
          name: "apis-reflect",
          namekey: "LABEL_REFLECT_APIS",
          iconclass: "api-head",
          children: [],
          hide: true
        }
      ],
      open: true
    },
    {
      name: "apis-third-party",
      namekey: "APIS_THIRD_PARTY",
      hide: true,
      subGroups: []
    }
  ];

  public SERVICE_TYPES = {
    'DATA_SERVICE': 'DataService',
    'WEB_SERVICE': 'WebService',
    'JAVA_SERVICE': 'JavaService',
    'SECURITY_SERVICE': 'SecurityServiceType',
    'SOAP_SERVICE': 'SoapService',
    'OPEN_API_SERVICE': 'OpenAPIService'
  };

  TARGET = 'APIDesigner';
  API_META: any = {
    get: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/apidocs/services/:serviceId",
      method: "GET"
    },
    update: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/apidocs/services/:serviceId",
      method: "POST"
    },
    test: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/TEST_URL",
      method: "POST"
    },
    /*returns the list of controllers associated with a service*/
    getControllers: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/apidocs/services/:serviceId/tags",
      method: "GET"
    },
    /*returns the list of endpoints associated with a controller*/
    getEndpoints: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/apidocs/services/:serviceId/:tagName",
      method: "GET"
    },
    updateRestService: {
      url:
        environment.SERVICES_BASE_PATH +
        'services/projects/:projectId/restservice',
      method: 'PUT',
    },
  };
  isSwaggerInfoLoading: boolean = false;
  apiDocs: any;
  _apiDocsSubject = new Subject();
  _apiConfiguredProviderSubject = new Subject();
  _apiMockEnabledSubject = new Subject();
  _loadSwaggerSubject = new Subject();
  _generateAPINodeClick = new Subject();
  openSubPopup= new Subject();
  _updateDesignFactory = new Subject();
  _deleteSelectedService = new Subject();
  $_deleteSelectedService = this._deleteSelectedService.asObservable();
   deleteEvent : Event;
   _refreshApiService = new Subject();
   $__refreshApiService = this._refreshApiService.asObservable();


  constructor(private wmHttpService: WmHttpService, private location: Location, private routerService: RouterHistoryService, private i18nService: I18nService, private webService: WebserviceService, private oAuthService: OauthService, private router: Router,private dialogService: DialogService,private projectService: ProjectService, private serviceFactory: ServiceFactoryService,private eventMangerService: EventManagerService, private notificationService: NotificationService) {
    this.dialogService = inject(DialogService);
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.serviceTypeConstants = this.SERVICE_TYPES;
    this.locale = this.i18nService.getMessages();
    this.typeService = inject(TypeFactoryService);
    this.wsManager = inject(WmsWorkspaceManagerService);
  }

  /*security service of application is also not editable*/
  ctrlOptions = {
    'readOnlyMode': false,
    'hasImportAPI': true,
    'isDescriptionEditable': (apiname: any) => {
      return apiname !== 'security-services';
    },
    'isMethodParamsVisible': (apiname: any) => {
      return apiname === 'java-services' || apiname === 'soap-services';
    },
    'isMethodUrlEditable': (apiname: any) => {
      return (apiname === 'soap-services' || apiname === 'java-services');
    },
    'isMethodTypeEditable': (apiname: any) => {
      return (apiname === 'soap-services' || apiname === 'java-services');
    }
  };

  // Method to filters endpoint based on search key.
  endPointFilter(searchKey: string) {
    let queryTag, procedureTag;
    if ((this.activeServiceType === 'DataService' || this.activeServiceType === 'OpenAPIService') && this.currentService) {
      this.currentService.filteredApis = this.apiFilter(this.currentService.apis, searchKey, this.activeServiceType);
      this.currentService.open = this.currentService.filteredApis.length > 0;
      //Filter query and procedure apis
      queryTag = find(this.currentService.apis, { 'controllerName': this.QUERY_CONTROLLER });
      procedureTag = find(this.currentService.apis, { 'controllerName': this.PROCEDURE_CONTROLLER });
      //Check if query and procedure match the search key
      if (queryTag && procedureTag) {
        queryTag = this.apiFilter([queryTag], searchKey, this.activeServiceType);
        procedureTag = this.apiFilter([procedureTag], searchKey, this.activeServiceType);
        this.currentService.queryTag = queryTag[0];
        this.currentService.procedureTag = procedureTag[0];
      }
    } else {
      this.filteredServices = this.apiFilter(this.services, searchKey);
      if (this.CORE_API_SERVICES.includes(this.filteredServices[0].type) ) {
        this._loadSwaggerSubject.next(this.filteredServices[0]);
      }
    }
  }

  apiFilter(apis: any, searchKey: any, type?: any) {
    const RELATIVE_PATH_KEY = 'x-WM-RELATIVE_PATH';
    if (!apis) {
      return [];
    }
    if (type) {
      return filter(apis, function (api) {
        return includes(toLower(api[RELATIVE_PATH_KEY]), toLower(searchKey));
      });
    }
    return filter(apis, function (service) {
      return includes(toLower(service.apis && service.apis[0][RELATIVE_PATH_KEY]), toLower(searchKey));
    });
  }


  getApiDesignerService() {
    return this.apiDesignerService;
  }

  triggerMockServer() {
    const urlParams = {
      projectID   : this.projectService.getProjectId(),
      serviceID   : this.activeApi.serviceId,
      enableMock  : true,
      showSpinner : false
    };
    (this.webService.updateMockServer(urlParams) as Promise<any>).then((resp: any) => {
        let pollParams = {
                 projectID   : this.projectService.getProjectId(),
                 serviceID   : this.activeApi.serviceId,
                 showSpinner : false
            },
            pollInterval = setInterval(() => {
                (this.webService.pollMockServerStatus(pollParams) as Promise<any>).then((pollResponse: any) => {
                     if(includes(["RUNNING", "FAILED"], pollResponse.status)) {
                      let toasterInfo;
                      window.localStorage.getItem('mock-server-intro-done') == 'true' ?
                        toasterInfo = {
                          success: { title: this.locale.TITLE_MOCK_SERVICE_LAUNCH_SUCCESS, description: this.locale.MESSAGE_MOCK_SERVICE_LAUNCH_SUCCESS.replace("${0}", urlParams.serviceID) },
                          error: { title: this.locale.TITLE_MOCK_SERVICE_LAUNCH_FAILURE, description: this.locale.MESSAGE_MOCK_SERVICE_LAUNCH_FAILURE.replace("${0}", urlParams.serviceID) }
                        } :
                        toasterInfo = {
                          success: { title: this.locale.TITLE_MOCK_SERVICE_CREATE_SUCCESS, description: this.locale.MESSAGE_MOCK_SERVICE_CREATE_SUCCESS.replace("${0}", urlParams.serviceID) },
                          error: { title: this.locale.TITLE_MOCK_SERVICE_CREATE_FAILURE, description: this.locale.MESSAGE_MOCK_SERVICE_CREATE_FAILURE.replace("${0}", urlParams.serviceID) }
                        }
                        if (pollResponse.status === "RUNNING") {
                          this.notificationService.show('success', toasterInfo.success.title, toasterInfo.success.description)
                        } else {
                          this.notificationService.show('error', toasterInfo.error.title, toasterInfo.error.description)
                        }
                       clearInterval(pollInterval);
                       this.dialogService.close("MockServerInProgressDialog");
                       this._apiMockEnabledSubject.next(true);
                       if(!this.mockServerIntroDone){
                        this.mockServerIntroDone = true;
                        window.localStorage.setItem('mock-server-intro-done','true');
                       }
                       this.initApiViewer(this.activeApiHead.api, true, undefined, undefined, true);
                       this.isMockEnabled = true;
                       this.config.useProxy = true;
                       this.eventMangerService.emitupdateMockAPIResponse('')
                     }
                }, (error: any) => {
                    clearInterval(pollInterval);
                    this.dialogService.close("MockServerInProgressDialog");
                });
            },3000);
    }, (error: any) => {
        this.dialogService.close("MockServerInProgressDialog");
    });
  }

  stopMockServer(urlParams: any) {
    (this.webService.updateMockServer(urlParams) as Promise<any>).then((resp: any) => {
        this.isMockEnabled = false;
        this.eventMangerService.emitupdateMockAPIResponse('')
        this._apiMockEnabledSubject.next(false);
        this.config.useProxy = true;
        this.initApiViewer(this.activeApiHead.api, true, undefined, undefined, true);
    }, (error: any) => {
        this.dialogService.close("MockServerInProgressDialog");
    });
}

  /*Gets the endpoints associated to a controller*/
  getEndpoints(params: any) {
    return this.wmHttpService.execute({
      target: "APIDesigner",
      action: "getEndpoints",
      pathParams: params.urlParams,
      spinnerInfo: {
        showSpinner: params.showSpinner,
        spinnerMsg: this.locale.LABEL_PREPARING_APIS
      }
    });
  }

  updateSwagger(params: any) {
    return this.wmHttpService.execute({
      target: "APIDesigner",
      action: "update",
      pathParams: params.pathParams,
      data: params.data,
      headers: params.headers
    });
  }

  getOpenAPISecurityConfig() {
    const connectionParams = {
      'urlParams': { 'projectId': this.projectService.getProjectId(), 'serviceId': this.serviceId },
      showSpinner : false
    };
    (this.webService.getOpenAPISecurityConfiguration(connectionParams) as Promise<any>).then((response: any) => {
      this.config = {};
      this.config.host = response.host;
      this.config.basePath = response.basePath;
      this.config.useProxy = get(response, 'proxySettings.web') === this.RUNTIME_CALL_MODE.PROXY ? true : false;
      this.config.withCredentials = get(response, 'proxySettings.withCredentials');
      this.config.securityConfigs = response.securityConfigs;
      const oAuthConfig = this.config.securityConfigs.filter((security: any) => {
        return security.type.toLowerCase() === 'oauth'
      })[0];
      if (oAuthConfig && oAuthConfig.providerId) {
        this.providerId = oAuthConfig.providerId;
        this.getOauthUrl(oAuthConfig);
      } else {
        this.providerId = null;
        this.authorizationUrl = null;
        this.activeProvider = null;
      }
    }).catch((error: any)=>{
    });
  }


  getOauthUrl(oAuthConfig: any) {
    const urlParams = {
      providerId  : oAuthConfig.providerId,
      showSpinner : false
    };
    (this.oAuthService.getAuthorizationUrl(urlParams) as Promise<any>).then((response) => {
      this.authorizationUrl = response;
    }).catch((error: any) => {
    });
    this.updateActiveProvider(oAuthConfig.providerId);
  }

  updateActiveProvider(providerId: any) {
    const params = {
      showSpinner : false
    };
    (this.oAuthService.loadConfiguredProviders(params) as Promise<any>).then((response) => {
      this.activeProvider = find(response, { providerId: providerId });
    }).catch((error: any) => {
    });
  }


  getActiveModels(modelsArr: any) {
    let modelObj: any = {};
    modelsArr?.forEach((model: any) => {
      modelObj[model.id] = model;
    });
    return modelObj;
  }

  /*Gets the controller Info for a service based on its Id*/
  getControllers(serviceId: any, reloadFlag: Boolean) {
    return new Promise((res, rej) => {
      const params = {
        'urlParams': {
          'projectId': this.projectService.getProjectId(),
          'serviceId': serviceId
        },
        showSpinner: false
      };

      /*It returns the service object where tag names are the keys*/
      this.getControllersInfo(params, reloadFlag).then((response: any) => {
        res(response);
      }).catch((errMsg: any) => {
        /* error handler */
        this.services = [];
        this.noServicesFound = true;
        this.loadingApi = false;
        rej(errMsg);
      });
    });
  }

  /*Gets the endpoints for a controller related to a service based on its Id*/
  getEndpointsInfo(serviceId: any, tagName: any, forceReload: boolean) {
    return new Promise((res, rej) => {
      const params = {
        'urlParams': {
          'projectId': this.projectService.getProjectId(),
          'serviceId': serviceId,
          'tagName': tagName,
        },
        showSpinner: forceReload
      };
      if (!tagName) {
        this.getControllers(serviceId, forceReload).then((controllers: any) => {
          params.urlParams.tagName = Object.keys(controllers)[0];
          /*It returns the swagger object of a controller related to a service*/
          (this.getEndpoints(params) as Promise<any>).then((response: any) => {
            res(response);
          }).catch((errMsg) => {
            rej(errMsg);
          });
        }).catch((errMsg: any) => {
          rej(errMsg);
        });
      } else {
        /*It returns the swagger object of a controller related to a service*/
        (this.getEndpoints(params) as Promise<any>).then((response) => {
          res(response);
        }).catch((errMsg: any) => {
          rej(errMsg);
        });
      }
    });
  }


  /**
 * description: This method sets the api active, and gets the parsed apiDocs(ie. the model object).
 *
 * @param api: There Service object.
 * @param forceReload: [boolean] If set true a request is sent to get updated swagger. else cached swagger is loaded.
 */
  _setActiveApi(api: any, forceReload: boolean, loadSwagger?: boolean) {
    this.hideActions = false;
    let parentService = api.serviceId;
    this.serviceId = api.serviceId;
    // for core api services, load swagger when new endpoint is clicked
    if (this.CORE_API_SERVICES.includes(api.serviceType) && loadSwagger) {
      const serviceObj = this.filteredServices.find((service: any) => service.name === api.serviceId);
      this._loadSwaggerSubject.next(serviceObj);
    }
    //make security config GET call with serviceid
    if (api.serviceType === 'OpenAPIService') {
      this.getOpenAPISecurityConfig();
    }
    /* mark previous selected api as inactive */
    if (this.activeApi) {
      this.activeApi.isActive = false;
    }
    //Initializing search filters
    this.searchKeys = { 'methodType': 'All Methods' };
    this.activeApi = api;
    this.activeApi.isActive = true;
    const endPointsList =  document.getElementsByClassName('end-points-list');
    if (endPointsList.length) {
      const activeEndPoint = $(endPointsList).find('li.active');
      let urlData: any = {};
      if (activeEndPoint && !this.isSettingsApi ) {
        if (activeEndPoint.html() === this.activeApi['x-WM-RELATIVE_PATH'] && $(document).find('.category.active .openapi-heading').html() === this.activeApi.serviceId) {
          const tagName: string = this.activeApiHead.api && this.activeApiHead.api.activeTag ? this.activeApiHead.api.activeTag : this.activeApi['x-WM-RELATIVE_PATH'];
          const path = '/apis/' + this.activeApiHead.api.name + '/' + tagName + window.location.search;
          if (window.location.pathname !== path) {
            setTimeout(() => {
              $(endPointsList).find('li.active')?.click();
            }, 0);
            this.routerService.urlHistory.push(path);
            urlData[this.projectService.getProjectId()] = this.routerService.urlHistory;
            sessionStorage.setItem('WMPathInfo', JSON.stringify(urlData));
          }
        } else {
          if(!this.reimportRefreshData) {
            const tagName: string = this.activeApiHead.api && this.activeApiHead.api.activeTag ? this.activeApiHead.api.activeTag : this.activeApi['x-WM-RELATIVE_PATH'];
            let path = '/apis/' + this.activeApiHead?.api.name + '/' + tagName;
            this.router.navigate([path]);
            this.routerService.urlHistory.push(path);
            setTimeout(() => {
              let tagNode: any = $(endPointsList).find('li:contains(' + tagName + ')');
              if (tagNode.length === 1) {
                tagNode.click();
              } else if (tagNode.length > 1) {
                for (let i = 0; i < tagNode.length; i++) {
                  if (tagNode[i].textContent === tagName) {
                    tagNode[i].click();
                  }
                }
              }
            }, 0);
            urlData[this.projectService.getProjectId()] = this.routerService.urlHistory;
            sessionStorage.setItem('WMPathInfo', JSON.stringify(urlData));
          }
        }
      } else if (this.isSettingsApi && !this.reimportRefreshData) {
        this.router.navigate(['/apis/' + this.activeApiHead?.api.name + '/settings']);
        const settingsEl = document.getElementById('api_designer_settings');
        settingsEl?.click();
      }
      this.reimportRefreshData = false;
      if(this.currentActiveNode) this.currentActiveNode = null
    } else if (this.currentActiveNode) { // If the last node has no services, generate click on current active service
      const apiNodes: any = document.getElementsByClassName('section-title');
      for (let i=0; i < apiNodes.length; i++) {
        const apiTitle = apiNodes[i].title.toLowerCase();
        if ((this.CORE_API_SERVICES.includes(this.currentActiveNode?.servicename) && apiTitle.includes(this.currentActiveNode?.name.split('-')[0])) ||
          (this.currentActiveNode?.name === apiTitle)) {
            let path = '/apis/' + this.activeApiHead?.api.name + '/' + this.activeApi['x-WM-RELATIVE_PATH']
            this.router.navigate([path]);
            this.routerService.urlHistory.push(path);
            apiNodes[i].click();
            this.currentActiveNode = undefined;
        }
      }
    }else{
      let urlData: any = {};
      let path = '/apis/' + this.activeApiHead?.api.name + '/' + this.activeApi['x-WM-RELATIVE_PATH'];
      this.router.navigate([path]);
      this.routerService.urlHistory.push(path);
      urlData[this.projectService.getProjectId()] = this.routerService.urlHistory;
      sessionStorage.setItem('WMPathInfo', JSON.stringify(urlData));
    }

    this.models = this.getActiveModels(api.models);
    this.loadingApi = true;
    /*Fetching the api docs from the map*/
    this.getEndpointsInfo(parentService, api.controllerName, forceReload).then((apiDocs: any) => {
      this.loadingApi = false;
      if (!this.isSwaggerInfoLoading) {
        apiDocs['definitions'] = this.swaggerInfo && this.swaggerInfo['definitions'];
        this._apiDocsSubject.next({'apiDocs': apiDocs});
      } else {
        this.apiDocs = apiDocs;
      }

    }, (error: any) => {
      this.hideActions = true;
      this.loadingApi = false;
    });


  }

  initServices(type: any, reloadFlag: boolean) {
    return this.serviceFactory.getServicesWithType(reloadFlag).then((response: any) => {
      this.services = [];
      response.forEach((service: any) => {
        if (service.type === type) {
          this.services.push(service);
        }
      });
      return Promise.resolve(this.services);
    }).catch((err) => Promise.reject(err));
  }


  isDataBaseService(type: any) {
    return type === this.serviceTypeConstants.DATA_SERVICE;
  }

  initServiceControllers(service: any, forceReload: Boolean = false) {
    return new Promise((res, rej) => {
      this.getControllers(service.name, forceReload).then((tags: any) => {
        service.apis = [];
        /*Every controller becomes a service*/
        Object.keys(tags).forEach((tag) => {
          service.apis.push({
            'x-WM-RELATIVE_PATH': tag && tag.replace(/Controller$/, ''),
            'controllerName': tag,
            'description': tags[tag].description,
            'serviceId': service.name,
            'serviceType': service.type
          });
        });
        this.services.forEach((item: any) => {
          if (service.name === item.name) {
            item.apis = service.apis;
          }
        });
        this.endPointFilter('');
        res(this.services);
      }).catch(() => {
        rej();
      });
    });

  }

  //Returns index of first table found in the array of controllers.
  getFirstTableIndex(controllers: any) {
    let index = findIndex(controllers, (controller: any) => {
      return !includes(['ProcedureExecution', 'QueryExecution'], controller[this.RELATIVE_PATH_KEY]);
    });
    return index === -1 ? 0 : index;
  }

  /* initializes the api viewer, based on the provided service type*/
  initApiViewer(api: any, forceReload: boolean, initServiceIndex?: any, initApiIndex?: any, isMockReload?: boolean) {
    let forceControllerReload = forceReload,
      servicetype = api.servicename;
    this.loadingApi = true;
    this.spinnerMessage = this.locale.LABEL_PREPARING_APIS;
    initServiceIndex = initServiceIndex || 0;
    this.initServices(servicetype, forceReload).then((services: any) => {
      this.noServicesFound = !services?.length;
      this.services = cloneDeep(services);
      if (this.services[initServiceIndex]) {
        if (this.isDataBaseService(servicetype)) {
          initServiceIndex = findIndex(this.services, { 'name': api.name });
          initServiceIndex = initServiceIndex === -1 ? 0 : initServiceIndex;
          this.initServiceControllers(this.services[initServiceIndex], forceControllerReload).then(() => {
            /*setting the first api as active api*/
            this.services[initServiceIndex]['open'] = true;
            this.currentService = this.services[initServiceIndex];
            // To make the first table selected when a database service is selected.
            if (initApiIndex === undefined) {
              initApiIndex = this.getFirstTableIndex(this.currentService.apis);
            }
            this._setActiveApi(this.currentService.apis[initApiIndex], forceReload);
            this.endPointFilter('');
          });
        } else if (servicetype !== this.SERVICE_TYPES.OPEN_API_SERVICE) {
          this.services.forEach((service: any, index: any) => {
            /* in case refresh, force reload only required service controllers */
            initApiIndex = initApiIndex || 0;
            forceControllerReload = forceReload && index === initServiceIndex;
            this.initServiceControllers(service, forceControllerReload).then(() => {
              /*setting the first api as active api*/
              if (index === initServiceIndex) {
                this._setActiveApi(this.services[initServiceIndex].apis[initApiIndex], forceReload);
              }
            });
          });
        } else {
          initServiceIndex = findIndex(this.services, { 'name': api.name });
          initServiceIndex = initServiceIndex === -1 ? 0 : initServiceIndex;
          this.initServiceControllers(this.services[initServiceIndex], forceControllerReload).then(() => {
            this.services[initServiceIndex]['open'] = true;
            this.currentService = this.services[initServiceIndex];
            if (this.currentService.name === api.name && this.currentService.isMockEnabled !== api.isMockEnabled && !isMockReload) {
              this.currentService.isMockEnabled = api.isMockEnabled;
            }
            /** If an active tag exists in session storage land indo that tag */
            if (api.activeTag) {
              this.currentService.apis.forEach((item: any, index: number) => {
                if (api.activeTag === item[this.RELATIVE_PATH_KEY]) {
                  initApiIndex = index;
                }
              });
            }
            /*setting the first api as active api*/
            if (initApiIndex === undefined) {
              initApiIndex = this.getFirstTableIndex(this.currentService.apis);
            }
            if (this.currentService.apis && !isMockReload) {
              // if import api view is there and first api is imported set currentactive node to the newly imported api
              if (this.services.length === 1 && (!this.currentActiveNode || this.currentActiveNode.name !== this.services[0].name)) {
                this.currentActiveNode = api;
              }
              this._setActiveApi(this.currentService.apis[initApiIndex], forceReload);
            }
            if (isMockReload) {
              this._updateDesignFactory.next(this.currentService);
            }
            this.endPointFilter('');
          });
        }
      } else if (!this.services.length) {
        this.location.replaceState('/apis/' + api.name + window.location.search);
        this.routerService.urlHistory.push(window.location.pathname);
        let urlData: any = {};
        urlData[this.projectService.getProjectId()] = this.routerService.urlHistory;
        sessionStorage.setItem('WMPathInfo', JSON.stringify(urlData));
      }
    });
  }

  /*Gets the list of the controllers associated to a service*/
  getControllersInfo(params: any, forceReload: Boolean) {
    return new Promise((res, rej) => {
      let serviceMap = this.serviceApiMap[params.urlParams.serviceId];
      /*Retrieve from the map*/
      if (!forceReload && serviceMap && this.serviceApiMap[params.urlParams.serviceId] && !this.fetchControllersInfo) {
        res( this.serviceApiMap[params.urlParams.serviceId]);
        return
      }
      (this.wmHttpService.execute({
        target: "APIDesigner",
        action: "getControllers",
        pathParams: params.urlParams,
        spinnerInfo: {
          showSpinner: params.showSpinner,
          spinnerMsg: this.locale.LABEL_PREPARING_APIS
        }
      }) as Promise<any>).then((response: any) => {
        this.serviceApiMap[params.urlParams.serviceId] = {};
        // Ordering the tags in alphabetical order
        response.sort((tag_a: any, tag_b: any)=>{
          let tag_aname = tag_a.name.toLowerCase()
          let tag_bname = tag_b.name.toLowerCase()
          if(tag_aname < tag_bname ) return -1
          if(tag_aname > tag_bname ) return 1
          return 0
        })
        response.forEach((tag: any) => {
          this.serviceApiMap[params.urlParams.serviceId][tag.name] = {};
          this.serviceApiMap[params.urlParams.serviceId][tag.name].description = tag.description;
        });
        this.fetchControllersInfo = false;
        res(this.serviceApiMap[params.urlParams.serviceId]);
      }).catch(() => {
        rej();
      });
    });
  }

  updateRestService(data: any, serviceName: string) {
    data.serviceId = serviceName;
    return this.wmHttpService.execute({
      target: this.TARGET,
      action: 'updateRestService',
      pathParams: {
        projectId: this.projectService.getProjectId(),
        serviceId: serviceName,
      },
      data: data,
    }) as Promise<any>;
  }

  saveCurrentApiIfDirty(nextApi: any){
    if(this.wsManager.isWSDirty()){
      this.apiToLoadNext = nextApi
      this.dialogService.open('unsavedChangesDialog_api')
      return true
    }
    return false
  }

  initiateDirtyCheck(){
    this.wsManager.setDirtyonWs(!isEqual(this.originalSwaggerSpec, this.tagInfoOriginal) );
  }

  openImportDialog(){
    this.dialogService.open('importAPIModal');
    this.importDialogOpened = true;
  }

  getEndpointsCount(path:any,type:string) {
    let endpointsCount = 0;
    Object.keys(path).forEach((value:any) => {
      Object.keys(path[value]).forEach(operations => {
        if (type && OPERATIONS.includes(operations)) {
          endpointsCount++;
      } else if (!type && operations !== "parameters") {
        endpointsCount++;
      }
      });
    })
    return endpointsCount;
  }
}
